export const tarifs_vacances = [
      {
            id: 1,
            photo: "/pictures/Tarifs/tarif_tres_haute_saison_new.jpg",
            photo2: "/pictures/Tarifs/tres_haute_saison.jpg",
            saison: "TRES HAUTE SAISON",
            date: "Les vacances d'été <br> (juillet - août)",
            prix: "510 €",
            position: 250,
            positionTablette: 10,
            show: false
      },

      {
            id: 2,
            photo: "/pictures/Tarifs/haute_saison_ping_pong_complet.jpg",
            photo2: "/pictures/Tarifs/haute_saison_ping_pong.jpg",
            saison: "HAUTE SAISON",
            date: "Début juillet, Fin août, <br> Et les vacances de Noël ",
            prix: "490 €",
            position: 375,
            positionTablette: 70,
            show: false
      },

      {
            id: 3,
            photo: "/pictures/Tarifs/jardin_plante.jpg",
            photo2: "/pictures/Tarifs/tarif_fleur.jpg",
            saison: "MOYENNE SAISON",
            date: "Les autres vacances scolaires, <br> Et mai - juin - septembre",
            prix: "360 €",
            position: 500,
            positionTablette: 150,
            show: false
      },
];

export const tarifs_basse_saison = [
      {
            id: 8,
            photo: "/pictures/Tarifs/basse_hiver_2.jpg",
            photo2: "/pictures/Tarifs/basse_hiver.jpg",
            periode: "La semaine",
            prix: "280 €",
            position: 200,
            positionTablette: 100,
            show: false
      },

      {
            id: 7,
            photo: "/pictures/Tarifs/tarif_semaine.jpg",
            photo2: "/pictures/Tarifs/tarif_coq.jpg",
            periode: "Weekend basse saison",
            prix: "210 €",
            position: 400,
            positionTablette: 200,
            show: false
      },

      {
            id: 5,
            photo: "/pictures/Tarifs/tarif_weekend.jpg",
            photo2: "/pictures/Tarifs/tarif_cloche.jpg",
            periode: "Weekend moyenne saison",
            prix: "240 €",
            position: 600,
            positionTablette: 300,
            show: false
      },

      {
            id: 6,
            photo: "/pictures/Tarifs/moyenne_saison.jpg",
            photo2: "/pictures/Tarifs/haute_saison.jpg",
            periode: "Possibilité de séjour mid-week",
            prix: "3,4,5,6 jours",
            position: 800,
            positionTablette: 400,
            show: false
      },
];
